<template>
    <div class="projectInfo" :class="{'gongcheng': type === 'gc', 'caigou': type === 'cg', 'changquan': type === 'cq'}">
        <span class="name">{{ item.bidName }}</span>
        <div class="siteContent">
            <div class="time">
                <img src="@/assets/images/icon_open.png" alt="" class="icon"/>
                {{ item.bidOpenTime }}
            </div>
            <div class="venue">
                <i class="el-icon-location-outline"></i>
                {{ item.openRoomName }}
            </div>
        </div>
        <div class="siteContent">
            <div class="time">
                <img src="@/assets/images/icon_eval.png" alt="" class="icon"/>
                {{ item.evaluationStartTime }}
            </div>
            <div class="venue">
                <i class="el-icon-location-outline"></i>
                {{ item.evaluationRoomName }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            default: () => {}
        },
        type: {
            type: String,
            default: 'gc'
        }
    }
}
</script>

<style lang="less" scoped>
.projectInfo {
    display: flex;
    padding: 8px 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    border-radius: 8px;
    .name {
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 26px;
        color: #001c52;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
    }
    .siteContent {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        color: #001b52a6;
        .icon {
            width: 22px;
            height: 22px;
        }
    }
}

.gongcheng {
    border-left: 2px solid #2568EC;
    background: #F0F7FF;
}
.caigou {
    border-left: 2px solid #FA8C16;
    background: #FFF7E6;
}
.changquan {
    border-left: 2px solid #13C2C2;
    background: #E6FFFB;
}
</style>
